import { Link } from 'react-router-dom';
import { LogoutIcon } from './iconsExtra.jsx';

/**
 * Desktop sidebar navigation. Hidden on mobile (<768px).
 * @param {{ navItems: Array, currentPath: string, onLogout: () => void }} props
 */
export default function LayoutSidebar({ navItems, currentPath, onLogout }) {
  return (
    <aside className="hidden md:flex flex-col w-56 min-h-[calc(100vh-52px)] bg-white border-r border-gray-100 py-4 px-3">
      <nav className="flex flex-col gap-1 flex-1">
        {navItems.map((item) => {
          const active = currentPath === item.path
            || (item.path !== '/' && currentPath.startsWith(item.path + '/'));
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-all ${
                active
                  ? 'bg-blue-50 text-[var(--color-accent)]'
                  : 'text-[var(--color-neutral)] hover:bg-gray-50 hover:text-gray-900'
              }`}
            >
              <item.Icon size={18} />
              <span>{item.label}</span>
            </Link>
          );
        })}
      </nav>
      <button
        onClick={onLogout}
        className="flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium text-[var(--color-neutral)] hover:bg-gray-50 hover:text-gray-900 mt-auto"
      >
        <LogoutIcon size={18} />
        <span>Déconnexion</span>
      </button>
    </aside>
  );
}
